import { render, staticRenderFns } from "./CoursesCompleted.vue?vue&type=template&id=16d632f4"
import script from "./CoursesCompleted.js?vue&type=script&lang=js&external"
export * from "./CoursesCompleted.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports